/**
 * AU product variant picker (legacy Dawn behavior).
 * Works with <variant-radios> / <variant-selects-au> and variants JSON in section fetch.
 */
(function () {
  class AUVariantPicker extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant?.featured_media) return;

      document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`).forEach((mediaGallery) => {
        mediaGallery.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
      });

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      if (newMediaModal) modalContent.prepend(newMediaModal);
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton?.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      document
        .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
        .forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateVariantStatuses() {
      const checked = this.querySelector(':checked');
      if (!checked) return;

      const selectedOptionOneVariants = this.getVariantData().filter((variant) => checked.value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];

      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked')?.value;
        const availableOptionInputsValue = selectedOptionOneVariants
          .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
          .map((variantOption) => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          if (input.tagName === 'OPTION') {
            input.innerText = input.getAttribute('value');
          } else {
            input.classList.remove('disabled');
          }
        } else if (input.tagName === 'OPTION') {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        } else {
          input.classList.add('disabled');
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
      if (this.currentVariant?.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      const productForm = section?.querySelector('product-form');
      productForm?.handleErrorMessage?.();
    }

    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection || this.dataset.section;

      fetch(
        `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection || this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sectionKey = this.dataset.originalSection || this.dataset.section;

          const swap = (id) => {
            const source = html.getElementById(`${id}-${sectionKey}`);
            const destination = document.getElementById(`${id}-${this.dataset.section}`);
            if (source && destination) destination.innerHTML = source.innerHTML;
            return { source, destination };
          };

          swap('price');
          const { source: inventorySource, destination: inventoryDestination } = swap('Inventory');
          const { source: skuSource, destination: skuDestination } = swap('Sku');
          swap('Volume');
          const { source: pricePerItemSource, destination: pricePerItemDestination } = swap('Price-Per-Item');

          if (skuSource && skuDestination) {
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }
          if (pricePerItemSource && pricePerItemDestination) {
            pricePerItemDestination.classList.toggle(
              'visibility-hidden',
              pricePerItemSource.classList.contains('visibility-hidden')
            );
          }

          document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
          if (inventoryDestination) {
            inventoryDestination.classList.toggle('visibility-hidden', inventorySource?.innerText === '');
          }

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(addButtonUpdated?.hasAttribute('disabled') ?? true, window.variantStrings.soldOut);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId, html, variant: this.currentVariant },
          });
        })
        .catch((e) => console.error(e));
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton || !addButtonText) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button?.querySelector('[name="add"]');
      const addButtonText = button?.querySelector('[name="add"] > span');
      if (!addButtonText) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
      document.getElementById(`Inventory-${this.dataset.section}`)?.classList.add('visibility-hidden');
      document.getElementById(`Sku-${this.dataset.section}`)?.classList.add('visibility-hidden');
      document.getElementById(`Price-Per-Item-${this.dataset.section}`)?.classList.add('visibility-hidden');
    }

    getVariantData() {
      if (!this.variantData) {
        const variantsScript = this.querySelector('script[data-product-variants]');
        if (variantsScript) {
          this.variantData = JSON.parse(variantsScript.textContent);
        } else {
          const scripts = this.querySelectorAll('script[type="application/json"]');
          for (const script of scripts) {
            const parsed = JSON.parse(script.textContent);
            if (Array.isArray(parsed)) {
              this.variantData = parsed;
              break;
            }
          }
        }
      }
      return this.variantData || [];
    }
  }

  class VariantRadios extends AUVariantPicker {
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('fieldset'))
        .map((fieldset) => {
          const checked = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) => radio.checked);
          return checked?.value;
        })
        .filter((value) => value != null);
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach((input) => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }
  }

  if (!customElements.get('variant-radios')) {
    customElements.define('variant-radios', VariantRadios);
  }

  if (!customElements.get('variant-selects-au')) {
    customElements.define('variant-selects-au', AUVariantPicker);
  }
})();
